var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32763 0.846052V1.49737H5.67237V0.846052C5.67237 0.634375 5.8352 0.455263 6.06316 0.455263C6.27484 0.455263 6.45395 0.634375 6.45395 0.846052V1.49737H7.10526C7.67516 1.49737 8.14737 1.96957 8.14737 2.53947V2.8V3.58158V7.75C8.14737 8.33618 7.67516 8.79211 7.10526 8.79211H1.89474C1.30855 8.79211 0.852631 8.33618 0.852631 7.75V3.58158V2.8V2.53947C0.852631 1.96957 1.30855 1.49737 1.89474 1.49737H2.54605V0.846052C2.54605 0.634375 2.70888 0.455263 2.93684 0.455263C3.14852 0.455263 3.32763 0.634375 3.32763 0.846052ZM1.63421 3.58158V7.75C1.63421 7.89655 1.74819 8.01053 1.89474 8.01053H7.10526C7.23553 8.01053 7.36579 7.89655 7.36579 7.75V3.58158H1.63421Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.1ad6810dd7afeff3dda8e9a4f3ad26ad.svg";
export { ForwardRef as ReactComponent };